module.exports = __webpack_public_path__ + "static/media/homevideo.98b4d3c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiperpic/homevideo.mp4
// module id = X12u
// module chunks = 52